<div id="title-report-container" class="title-report-container">
  @if (!items) {
    <div class="report-container">
      <app-loading-indicator [zIndex]="0" />
    </div>
  } @else {
    <div class="filters-container">
      <div class="flex-left">
        <sag-ui-select [label]="'summary.filter.reportingPeriod' | translate" [value]="reportingPeriods[0]" (change)="changeReportingPeriod($event)">
          <sag-ui-option value="all">{{ "generic.filter.allYears" | translate }}</sag-ui-option>
          @for (reportingPeriod of reportingPeriods; track reportingPeriod) {
            <sag-ui-option [value]="reportingPeriod">{{ "generic.filter.currentPeriod" | translate: { value: reportingPeriod } }}</sag-ui-option>
          }
        </sag-ui-select>

        <sag-ui-select [label]="'generic.filter.sortBy' | translate" [value]="noneSortOption" (change)="sortBy($event)">
          <sag-ui-option [value]="noneSortOption">{{ "generic.filter.none" | translate }}</sag-ui-option>
          @for (sortOption of sortByOptions; track sortOption.value + sortOption.direction) {
            <sag-ui-option [value]="sortOption">
              {{ "generic.filter." + sortOption.value | translate }} {{ "generic.filter." + sortOption.direction | translate }}
            </sag-ui-option>
          }
        </sag-ui-select>
      </div>

      <div class="flex-right">
        <sag-ui-select [label]="'generic.filter.groupByWithoutDots' | translate" [value]="selectedGroupByOption" (change)="group($event)">
          @for (groupOption of groupByOptions; track groupOption) {
            <sag-ui-option [value]="groupOption">{{ "generic.filter." + groupOption | translate }}</sag-ui-option>
          }
        </sag-ui-select>
      </div>
    </div>

    <mat-tab-group class="top-tab-group" [ngClass]="{ 'header-invisible': !items?.length }" [animationDuration]="0">
      @for (tab of getKeys(groupedItems); track tab) {
        <mat-tab [label]="'generic.filter.' + tab | translate">
          @let tabData = groupedItems[tab];
          @if (selectedGroupByOption === groupByOption.responsible) {
            <mat-tab-group class="bottom-tab-group" disableRipple="true">
              @for (level of getKeys(tabData); track level) {
                <mat-tab [label]="'generic.filter.level' | translate: { value: level }">
                  <div class="report-container">
                    @for (report of paginator.items; track report) {
                      <app-report-tile (click)="openReport(report)" [item]="report" />
                    }
                  </div>
                  <div class="paginator-container">
                    <app-paginator #paginator [data]="tabData[level] || []" [pageSizeOptions]="pageSizes" [pageSize]="pageSize" />
                  </div>
                </mat-tab>
              }
            </mat-tab-group>
          } @else {
            <div class="report-container">
              @for (report of paginator.items; track report) {
                <app-report-tile (click)="openReport(report)" [item]="report" />
              }
            </div>
            <div class="paginator-container">
              <app-paginator #paginator [data]="tabData || []" [pageSizeOptions]="pageSizes" [pageSize]="pageSize" />
            </div>
          }
        </mat-tab>
      }
    </mat-tab-group>
  }
</div>
